import React from "react";

function Burger() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="rgb(84 124 164)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M4 18h16M4 12h16M4 6h16"
      ></path>
    </svg>
  );
}

export default Burger;